import { AfterViewInit, Component, Inject } from '@angular/core';
import { ProductdesignerdService
       } from 'core/productdesignerd/productdesignerd.service';

const CHECK_CONNECTIVITY_INTERVAL = 10000; /* ms */
const FAILURE_THRESHOLD = 2; /* successive failed request */

@Component({
    selector: 'offline-notice',
    templateUrl: './offline-notice.component.html',
    styleUrls: ['./offline-notice.component.scss'],
    standalone: false
})
export class OfflineNoticeComponent implements AfterViewInit
{
  private failures: number = 0;

  constructor(
    @Inject(ProductdesignerdService) private pddService:
        ProductdesignerdService
  )
  {}

  public ngAfterViewInit(): void
  {
    setInterval(() => this.checkConnectivity(), CHECK_CONNECTIVITY_INTERVAL);
  }

  public get connected(): boolean {
    return this.failures < FAILURE_THRESHOLD;
  }

  private async checkConnectivity(): Promise<void>
  {
    try {
      if (await this.pddService.queryHeartbeat()) {
        this.failures = 0;
      } else {
        ++this.failures;
      }
    } catch (_) {
      // The productdesignerd domain is not known.
      // It may pop up soon, so we'll wait.
    }
  }
}
